
import { Vue, Component, Prop } from 'vue-property-decorator';
import T from '../../lang';

@Component
export default class GettingStarted extends Vue {
  @Prop({ default: false }) isUnder13User!: boolean;

  T = T;
}
